import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './ConfirmationModal.scss';
import { useTranslation } from 'react-i18next';
import cautionIconPath from '../../../assets/images/icons/caution-icon.png';

interface ConfirmationModalProps {
  showModal: boolean;
  onHide: () => void;
  onConfirm: () => void;
  title: string;
  bodyText: string;
  confirmButtonText: string;
  cancelButtonText: string;
  iconAlt?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  showModal,
  onHide,
  onConfirm,
  title,
  bodyText,
  confirmButtonText,
  cancelButtonText,
  iconAlt = 'Modal Icon',
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={showModal} onHide={onHide} size='sm' centered dialogClassName='confirmation-modal'>
      <div className='confirmation-modal__content'>
        <div className='confirmation-modal__icon-container'>
          <img src={cautionIconPath} alt={iconAlt} width='50' height='50' />
        </div>
        <Modal.Header closeButton>
          <Modal.Title className='confirmation-modal__title'>{t(title)}</Modal.Title>
        </Modal.Header>
        <Modal.Body className='confirmation-modal__body'>
          <p className='confirmation-modal__text'>{t(bodyText)}</p>
        </Modal.Body>
        <Modal.Footer className='confirmation-modal__footer'>
          <Button
            variant='primary'
            onClick={onConfirm}
            className='confirmation-modal__btn confirmation-modal__btn--confirm'
          >
            {t(confirmButtonText)}
          </Button>
          <Button
            variant='secondary'
            onClick={onHide}
            className='confirmation-modal__btn confirmation-modal__btn--cancel'
          >
            {t(cancelButtonText)}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
